import {
  getStoreId,
  removeStoreId,
  setStoreId,
} from "$/hooks/use-store-information"
import { RoleNotFoundError, StoresNotFoundError } from "$/lib/errors"
import { ExtendedUser, Route, Store } from "@repo/common"
import { AuthRequest } from "@repo/web-auth"

const findStore = async (authRequest: AuthRequest): Promise<Store> => {
  const stores = await authRequest<Store[]>({
    url: Route.STORE_CONTROLLER__FIND_ALL,
    method: "GET",
  })

  const [store] = stores
  if (!store) throw new StoresNotFoundError()

  return store
}

/** Picks and persists the store a freshly logged-in user lands in. */
export const determineStoreId = async (
  user: ExtendedUser,
  authRequest: AuthRequest,
): Promise<void> => {
  try {
    const existingStoreId = await getStoreId()
    if (existingStoreId) {
      // Validate the stored storeId is still valid for this user
      const isValidStore =
        user.isAdmin ||
        user.roles.some((role) => role.storeId === existingStoreId)

      if (isValidStore) return

      // If not valid, remove it and continue to determine new storeId
      await removeStoreId()
    }

    let newStoreId: string
    const role = user.roles[0]
    if (role) {
      newStoreId = role.storeId
    } else if (user.isAdmin) {
      const store = await findStore(authRequest)
      newStoreId = store.id
    } else {
      throw new RoleNotFoundError()
    }

    await setStoreId(newStoreId)
  } catch (e) {
    console.error("Failed to determine store ID:", e)
    throw e // Re-throw to handle in calling function
  }
}
